export default "__VITE_ASSET__B0ijI8zX__"